"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cellAlign_exports = {};
__export(cellAlign_exports, {
  CellAlign: () => CellAlign
});
module.exports = __toCommonJS(cellAlign_exports);
var import_core = require("@tiptap/core");
function firstNonEmpty(...values) {
  for (const value of values) {
    if (value !== null && value !== void 0 && value !== "") {
      return value;
    }
  }
  return null;
}
__name(firstNonEmpty, "firstNonEmpty");
const CellAlign = import_core.Extension.create({
  name: "cellAlign",
  addOptions() {
    return {
      types: [],
      blockTypes: ["paragraph", "heading"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: null,
            parseHTML: /* @__PURE__ */ __name((element) => firstNonEmpty(element.style.textAlign, element.getAttribute("data-text-align")), "parseHTML"),
            renderHTML: /* @__PURE__ */ __name((attributes) => {
              if (typeof attributes.textAlign !== "string") {
                return {};
              }
              return {
                "data-text-align": attributes.textAlign,
                style: `text-align: ${attributes.textAlign}`
              };
            }, "renderHTML")
          },
          verticalAlign: {
            default: null,
            parseHTML: /* @__PURE__ */ __name((element) => firstNonEmpty(element.style.verticalAlign, element.getAttribute("data-vertical-align")), "parseHTML"),
            renderHTML: /* @__PURE__ */ __name((attributes) => {
              if (typeof attributes.verticalAlign !== "string") {
                return {};
              }
              return {
                "data-vertical-align": attributes.verticalAlign,
                style: `vertical-align: ${attributes.verticalAlign}`
              };
            }, "renderHTML")
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setCellTextAlign: /* @__PURE__ */ __name((align) => ({ commands }) => {
        const updated = this.options.types.map((type) => commands.updateAttributes(type, { textAlign: align })).every((response) => response);
        this.options.blockTypes.forEach((type) => commands.resetAttributes(type, "textAlign"));
        return updated;
      }, "setCellTextAlign"),
      unsetCellTextAlign: /* @__PURE__ */ __name(() => ({ commands }) => {
        return this.options.types.map((type) => commands.resetAttributes(type, "textAlign")).every((response) => response);
      }, "unsetCellTextAlign"),
      setCellVerticalAlign: /* @__PURE__ */ __name((align) => ({ commands }) => {
        return this.options.types.map((type) => commands.updateAttributes(type, { verticalAlign: align })).every((response) => response);
      }, "setCellVerticalAlign"),
      unsetCellVerticalAlign: /* @__PURE__ */ __name(() => ({ commands }) => {
        return this.options.types.map((type) => commands.resetAttributes(type, "verticalAlign")).every((response) => response);
      }, "unsetCellVerticalAlign")
    };
  }
});
//# sourceMappingURL=cellAlign.js.map
